import { render } from "./MainLayoutInstitute.vue?vue&type=template&id=cb2e218a&scoped=true"
import script from "./MainLayoutInstitute.vue?vue&type=script&lang=js"
export * from "./MainLayoutInstitute.vue?vue&type=script&lang=js"

import "./MainLayoutInstitute.vue?vue&type=style&index=0&id=cb2e218a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2e218a"]])

export default __exports__